export default "__VITE_ASSET__po6CkBAo__"